import React from 'react'
import Scrollbars from 'react-custom-scrollbars'
import classNames from 'classnames'

import { Footer } from '../components'

export interface IWithScrollBarsAndFooterProps {
    scrollBarExtraClassName?: string
}

export const withScrollBarsAndFooter = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    return (props: P & IWithScrollBarsAndFooterProps) => (
        <Scrollbars className={classNames('scroll-wrapper', props.scrollBarExtraClassName)} >
            <WrappedComponent {...(props as P)}/>
            <Footer />
        </Scrollbars>
    )
}